import Head from "next/head"
import DefaultLayout from "@/components/DefaultLayout"
import MyAccountLayout from "@/components/MyAccountLayout"
import { useState, useEffect } from "react"
import styles from "@/styles/my-account/logindetails.module.scss"
import myAccountApi from '@/service/modules/myAccountApi'
import { Button, Form, Input, Table, message } from 'antd';
import { useCallbackState } from '@/utils/useRef'

export default function MyaccountStatus() {

  const [form] = Form.useForm();
  const [logRecordCount, setLogRecordCount] = useState(0)
  const [pageInfo, setPageInfo] = useCallbackState({ offset: 0, limit: 10 })
  const [dataSource, setDataSource] = useState([])
  // 获取登陆日志数据
  const getLoginDetail = async (parmas?: any) => {
    try {
      let res = await myAccountApi.loginDetail({ ...pageInfo, ...parmas })
      if (res.data) {
        const { logRecords, loginDetail, logRecordCount } = res.data
        setDataSource(logRecords)
        setLogRecordCount(logRecordCount)
        form.setFieldsValue(loginDetail)

      }
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    getLoginDetail()
  }, [])

  const columns = [
    {
      title: 'Login Time',
      dataIndex: 'customerLogtime',
      key: '1',
      align: 'center' as 'center'
    },
    {
      title: 'Login IP',
      dataIndex: 'customerIp',
      key: '2',
      align: 'center' as 'center'
    }
  ];

  // 表单验证成功
  const onFinish = async (values: any) => {
    const { password, confirmPassword } = values
    try {
      await myAccountApi.updatePassword({ 
        password: window.btoa(password),
        confirmPassword: window.btoa(confirmPassword)
      })
      form.resetFields();
      message.success("Successful")
    } catch (error) {
      console.error(error)
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  const validateMessages = {
    required: '${label} is required!'
  };

  const validatePasswordInput = (_:any, value: string) => {
    if (value && value.length < 6) {
      return Promise.reject(new Error('The password must contain at least 6 characters'));
    }
    return Promise.resolve();
  };

  const pageChange = (event: any) => {
    const { current, pageSize } = event
    const pageInfo = { offset: (current - 1) * pageSize , limit: pageSize }
    setPageInfo(pageInfo, (v: any) => {
      getLoginDetail(v)
    })
  }

  return (
    <>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals & Discounts | CrazySales
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta
          name="description"
          content="CrazySales.com.au - Australia's #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we've got it all, with free shipping on selected items!"
        ></meta>
      </Head>

      <DefaultLayout>
        <MyAccountLayout>
          <div className={styles['my-credits-status']}>
            <div className={styles['main-title']}>Login Details</div>

            <div className={styles['heading']}>
              <div className={styles['head']}>Change Login Password</div>
            </div>

            <p className={styles['password-desc']}>Wish to change your password? Enter your new password in the input boxes below.</p>

            <Form
              form={form}
              labelAlign="right"
              className={styles['my-form']}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              validateMessages={validateMessages}
            >
              <Form.Item label="Login Email:" name="login">
                <Input disabled={true} className={styles['login-detail-input']} />
              </Form.Item>
              <Form.Item label="New Password:" name="password" rules={[{ required: true }, {
                validator: validatePasswordInput,
              }]}>
                <Input.Password className={styles['login-detail-input']} />
              </Form.Item>
              <Form.Item label="Confirm Password:" name="confirmPassword" rules={[{ required: true }, ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Passwords are not identical'));
                },
              }), {
                validator: validatePasswordInput,
              }]}>
                <Input.Password className={styles['login-detail-input']} />
              </Form.Item>
              {/* <Form.Item label="First Name:" name="first_name">
                <Input disabled={true} className={styles['login-detail-input']} />
              </Form.Item>
              <Form.Item label="Last Name:" name="last_name">
                <Input disabled={true} className={styles['login-detail-input']} />
              </Form.Item> */}
              <Form.Item style={{ alignSelf: 'center' }}>
                <Button htmlType="submit" className={styles['submit-btn']} type="primary" >Save Changes</Button>
              </Form.Item>
            </Form>


            <div className={styles['heading']}>
              <div className={styles['head']}>Login History</div>
            </div>

            <Table rowKey="customerLogtime" columns={columns} dataSource={dataSource} onChange={pageChange} pagination={{ hideOnSinglePage: true, total: logRecordCount }} bordered />
          </div>
        </MyAccountLayout>
      </DefaultLayout>
    </>
  )
}